import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from '../libraries/photoswipe-default-ui';

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
 function parseThumbnailElements(el) {
    let thumbElements = el.querySelectorAll('li'),
        numNodes = thumbElements.length,
        items = [],
        liEl,
        linkEl,
        size,
        item;

    thumbElements.forEach(el => {
        linkEl = el.querySelector('a');

        size = linkEl.dataset.size.split('x');

        // create slide object
        item = {
            src: linkEl.getAttribute('href'),
            w: parseInt(size[0], 10),
            h: parseInt(size[1], 10)
        };

        if (linkEl.children.length > 0) {
            // <img> thumbnail element, retrieving thumbnail url
            item.msrc = linkEl.children[0].getAttribute('src');
        } 

        item.el = el; // save link to element for getThumbBoundsFn

        items.push(item);
    });

    return items;
};

// find nearest parent element
function closest(el, fn) {
    return el && ( fn(el) ? el : closest(el.parentNode, fn) );
};

// triggers when user clicks on thumbnail
function onThumbnailsClick(e) {
    e.preventDefault();

    // find root element of slide
    const clickedListItem = closest(e.target, function(el) {
        return (el.tagName && el.tagName.toUpperCase() === 'LI');
    });

    if (!clickedListItem) {
        return;
    }

    const clickedGallery = clickedListItem.parentNode,
        index = clickedListItem.dataset.index;

    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);

    return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
function photoswipeParseHash() {
    var hash = window.location.hash.substring(1),
        params = {};

    if( hash.length < 5) {
        return params;
    }

    var vars = hash.split('&');

    for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
            continue;
        }

        var pair = vars[i].split('=');  

        if (pair.length < 2) {
            continue;
        }  

        params[pair[0]] = pair[1];
    }

    if (params.gid) {
        params.gid = parseInt(params.gid, 10);
    }

    return params;
};

function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),

        getThumbBoundsFn: function(index) {
            // See Options -> getThumbBoundsFn section of documentation for more info
            var thumbnail = items[index].el.querySelector('img'), // find thumbnail
                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                rect = thumbnail.getBoundingClientRect(); 

            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
    };

    // PhotoSwipe opened from URL
    if (fromURL) {
        if (options.galleryPIDs) {
            // parse real index when custom PIDs are used 
            // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
            for (var j = 0; j < items.length; j++) {
                if (items[j].pid == index) {
                    options.index = j;
                    break;
                }
            }
        } else {
            // in URL indexes start from 1
            options.index = parseInt(index, 10) - 1;
        }
    } else {
        options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index) ) {
        return;
    }

    if (disableAnimation) {
        options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

    gallery.init();
};

function initPhotoSwipeFromDOM(gallerySelector) {
    // loop through all gallery elements and bind events
    const galleryElements = document.querySelectorAll(gallerySelector);

    galleryElements.forEach((el, i) => {
        el.setAttribute('data-pswp-uid', i + 1);
        el.addEventListener('click', onThumbnailsClick);
    });

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    const hashData = photoswipeParseHash();

    if (hashData.pid && hashData.gid) {
        openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
};


// execute above function
initPhotoSwipeFromDOM('.js-photo-gallery');